import React from 'react';
import { useAnnotationFontSize } from 'utils/hooks-util';
import { ReactComponent as CalloutDirectionSetterLeft } from 'icons/callouts-direction-setter-left.svg';
import { ReactComponent as CalloutDrodownArrow } from 'icons/callouts-dropdown-arrow.svg';
import { ANNOTATION_FONT_SIZE } from 'constants/feature/annotation-elements-constants';
import IconDropDown from 'components/common/icon-dropdown';
export const STATEMENT_ANNOTATIONS_UPDATE_BLOCK =
  'statement-annotations-update-block';
const ANNOTATION_SUMMARY_ICON_SIZE = '30px';
const STATEMENT_ANNOTATIONS_FONT_SIZE_BLOCK_ID =
  'statement-annotations-font-size-block-id';
const CALLOUT_DROP_DOWN_ARROW_WIDTH = 15;
const CALLOUT_DROP_DOWN_ARROW_HEIGHT = 30;
const StatementAnnotationsFontSize = ({
  setAnnotationsDisplayFontSize,
  disabled,
  statementId,
}) => {
  const { annotationDisplayFontSize, selectAnnotationPosition } =
    useAnnotationFontSize(parseInt(statementId), setAnnotationsDisplayFontSize);

  return (
    <div className={`${STATEMENT_ANNOTATIONS_UPDATE_BLOCK}`}>
      <div className={`${STATEMENT_ANNOTATIONS_UPDATE_BLOCK}__icons`}>
        <IconDropDown
          displayIconPlaceholder={
            <CalloutDirectionSetterLeft
              width={ANNOTATION_SUMMARY_ICON_SIZE}
              height={ANNOTATION_SUMMARY_ICON_SIZE}
            />
          }
          tooltip={{
            id: STATEMENT_ANNOTATIONS_FONT_SIZE_BLOCK_ID,
            text: disabled
              ? null
              : 'statement-annotations-font-size-block-tooltip',
            position: 'top',
          }}
          arrowIcon={
            <CalloutDrodownArrow
              width={CALLOUT_DROP_DOWN_ARROW_WIDTH}
              height={CALLOUT_DROP_DOWN_ARROW_HEIGHT}
            />
          }
          optionSize={annotationDisplayFontSize.fontSize}
          options={ANNOTATION_FONT_SIZE}
          value={annotationDisplayFontSize.annotationFontSize}
          onSelectOption={(position) => selectAnnotationPosition(position)}
          disabled={disabled}
        />
      </div>
    </div>
  );
};
export default StatementAnnotationsFontSize;
